module.exports = __webpack_public_path__ + "static/media/chopstick.40890b12.gif";